import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Stack">
                            <h2>Blockchain Software Development Tech Stack</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                      <p>Our Blockchain software development company personnel are equipped with Solidity, Java, Python, C++, Ruby, and other programming languages to create high-end Blockchain tool.</p>
                        <p>TekRevol follows industry-approved practices to create Blockchain software and DLT solutions that enhance security, improve traceability, refresh transparency, reduce costs, and enable quick transactions.</p>
                        <p>The practices are applied throughout the process, from requirement gathering and analysis to architecture and conceptualization to application development and deployment.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;